import { useEffect, useState } from "react";
import api from "../../../conf/api";

const IDLE = { status: "idle", rawVideos: [], watermarkUrl: null, error: null };

/**
 * A WGID's raw video files, for the "merge multiple raw clips" option in the
 * VRE editor — GET /mrss/raw-videos/<wgid>/ (raw_video_views.py), which
 * proxies WooGlobe Admin Portal's MRSS external video-lifecycle API so the
 * shared secret never reaches the browser.
 *
 * Unlike useRenderEngine, nothing is cached across WGIDs: every `wgid` change
 * (or `enabled` turning on) fetches fresh.
 *
 * Returns { status: "idle" | "loading" | "ready" | "error", rawVideos, watermarkUrl, error }.
 */
export default function useRawVideos(wgid, enabled = true) {
  const [state, setState] = useState(IDLE);

  useEffect(() => {
    if (!enabled || !wgid) {
      setState(IDLE);
      return undefined;
    }
    let live = true;
    setState({ ...IDLE, status: "loading" });
    api
      .get(`/mrss/raw-videos/${encodeURIComponent(wgid)}/`)
      .then((res) => {
        if (!live) return;
        setState({
          status: "ready",
          rawVideos: Array.isArray(res.data?.raw_videos) ? res.data.raw_videos : [],
          watermarkUrl: res.data?.watermark_url ?? null,
          error: null,
        });
      })
      .catch((err) => {
        if (!live) return;
        setState({ ...IDLE, status: "error", error: err });
      });
    return () => {
      live = false;
    };
  }, [wgid, enabled]);

  return state;
}
